import * as SharedAcross from '../utilities/SharedAcross.js';

function App(props) {

  var maintabstyleclose = "nav-item navchoice";
  var maintabstyleactive = "nav-item navchoice active";

  var options = props.options;
  var setSelections = props.setSelections;
  var currentAnswer = props.currentAnswer;
  var comp = props.comp;
  var nosColumns = props.nosColumns;

  function clickSelect(selectId){
    return function(e){
      setSelections(selectId);
      e.stopPropagation();
    }
  }

  function compareAnswers(iAns){
    if (!comp){
      return iAns === currentAnswer;
    }else {
      if (!currentAnswer && !iAns){
        return true;
      }else if (!currentAnswer || !iAns){
        return false;
      }else{
        for (var i = 0; i < comp.length; i++){
          if (iAns[comp[i]] === currentAnswer[comp[i]]){
          }else{
            return false;
          }
        }
        return true;
      }
    }
  }

  var nosColumnsToUse = 4;
  if (nosColumns){
    nosColumnsToUse = nosColumns;
  }
  var widthPerc = (100/nosColumnsToUse) + '%';
  
  var grid = SharedAcross.convertToGrid(options, nosColumnsToUse, true);
  var rows = grid.map((aRow, index)=>{
    var cells = aRow.map((aCell, index2)=>{
      if (aCell){

        let style = "";
        if (compareAnswers(aCell.i)) {
          style = maintabstyleactive
        } else{
          style = maintabstyleclose
        }
        return (<li className={style} style={{width:widthPerc}} onClick={clickSelect(aCell.i)} > <a data-toggle="pill" className="nav-link rounded-pill cursorpoint"> {aCell.t} </a> </li>)
      }else{
        return null;
        // return <td key={index2} style={{width:widthPerc}}></td>
      }
    })

    return <ul role="tablist" className="nav bg-light nav-pills rounded-pill nav-fill mb-3 navchoicelist">
            {cells}
          </ul>

    // return <tr key={index}>{cells}</tr>
  })

    // <label> {aQuestion.q}
    // </label>
    // {errorLine}
  return <div className="form-group">
    {rows}
  </div>


}

export default App;
